// extracted by mini-css-extract-plugin
export default {"empty":"Leads_empty_iQBAT"};